import { useDispatch, useSelector } from 'react-redux';
import { selectTermsDurationInDays, selectTermsDurations } from '../../../../../../../selectors/termsDurations';
import { selectAnalyticsOfferStatus, selectAnalyticsProduct } from '../../../../../../../selectors/analytics';
import { getActiveDurationIdx } from '../utils';
import { useCallback } from 'react';
import { setTermsDuration } from '../../../../../../../actions/termsDurations';
import { trackDurationClick, trackShowDurations } from '../tracking';

export const useDurations = () => {
  const dispatch = useDispatch();

  const durations = useSelector(selectTermsDurations);
  const selectedDurationInDays = useSelector(selectTermsDurationInDays);
  const analyticsOfferStatus = useSelector(selectAnalyticsOfferStatus);
  const { id, variant } = useSelector(selectAnalyticsProduct);
  const activeDurationIndex = getActiveDurationIdx(durations, selectedDurationInDays);

  const setDuration = useCallback(
    ({ duration, discount }: { duration: number; discount: number }) => {
      dispatch(setTermsDuration(duration));

      trackDurationClick({
        discount,
        days: duration,
        analyticsOfferStatus,
        form_id: id as number,
        vas: variant as string,
      });
    },
    [dispatch, analyticsOfferStatus, id, variant],
  );

  const handleShow = useCallback(() => {
    trackShowDurations({
      analyticsOfferStatus,
      form_id: id as number,
      vas: variant as string,
    });
  }, [analyticsOfferStatus, id, variant]);

  return {
    durations,
    selectedDurationInDays,
    activeDurationIndex,
    onChange: setDuration,
    onShow: handleShow,
  };
};
